import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { TPipe } from '../../../core/i18n/t.pipe';
import { I18nService } from '../../../core/i18n';


@Component({
    selector: 'charla-priority',
    templateUrl: 'priority.component.html',
    styleUrls: ['priority.component.scss'],
    imports: [TPipe, CommonModule, NgbDropdownModule]
  })
  export class CharlaPriorityComponent {

    private i18n = inject(I18nService);
    @Input() priority: number;
    @Output() public change: EventEmitter<any> = new EventEmitter();
    lookup: string[] = [this.i18n.t('inbox.components.ticket_priority.priority.low_priority', 'Low Priority'), this.i18n.t('inbox.components.ticket_priority.priority.normal_priority', 'Normal Priority'), this.i18n.t('inbox.components.ticket_priority.priority.high_priority', 'High Priority')]; 

    constructor(
    ){

    }

    set_priority(priority: number){
        this.change.emit( priority );
    }



  }